import { motion } from "framer-motion";
import { ShoppingBag } from "lucide-react";
import { Logo } from "./Logo";
import { useCart } from "../lib/cart";
import { scrollToId } from "../lib/smooth";

const LINKS = [
  ["Shelves", "shelves", "guna-nav-bento-link"],
  ["Catalogue", "catalogue", "guna-nav-catalogue-link"],
  ["Visit", "visit", "guna-nav-storeinfo-link"],
];

export const Nav = () => {
  const { count, setOpen } = useCart();
  return (
    <motion.header
      initial={{ y: -40, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
      className="fixed inset-x-0 top-0 z-40 border-b border-black/5 bg-[#FFFFFF]/75 backdrop-blur-xl"
    >
      <div className="mx-auto flex h-[72px] max-w-[1400px] items-center justify-between px-5 md:px-10">
        <button data-testid="guna-header-logo" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>
          <Logo />
        </button>
        <nav className="hidden items-center gap-10 md:flex">
          {LINKS.map(([label, id, tid]) => (
            <button key={id} data-testid={tid} onClick={() => scrollToId(id)}
              className="group relative font-mono-g text-xs uppercase tracking-[0.25em] text-stone-700 transition-colors hover:text-[#1C1917]">
              {label}
              <span className="absolute -bottom-1 left-0 h-px w-0 bg-[#D62828] transition-[width] duration-300 group-hover:w-full" />
            </button>
          ))}
        </nav>
        <motion.button whileTap={{ scale: 0.94 }} data-testid="guna-cart-trigger-button" onClick={() => setOpen(true)}
          className="flex items-center gap-2 rounded-full border border-[#D62828]/40 px-4 py-2 text-sm text-[#1C1917] transition-colors hover:bg-[#D62828] hover:text-[#FFFFFF]">
          <ShoppingBag className="h-4 w-4" />
          <span className="hidden sm:inline">Collect basket</span>
          <motion.span key={count} initial={{ scale: 1.6 }} animate={{ scale: 1 }} data-testid="guna-cart-count"
            className="font-mono-g grid h-5 min-w-5 place-items-center rounded-full bg-[#D62828] px-1 text-[11px] text-[#FFFFFF]">
            {count}
          </motion.span>
        </motion.button>
      </div>
    </motion.header>
  );
};
